import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getBundleAvailability } from 'store/ProductDetails/bundles/selectors';
import { setProductDetailsOfficesRaw } from 'store/ProductDetails/delivery/actions';

import ViewLayout from '../_ViewLayout';
import { FlocktoryProductContainer } from '../../components';
import BundleContainer from '../../components/BundleContainer';
import SchemaProductContainer from '../../components/SchemaProductContainer';

/**
 * Simple Product Details View, extends page ViewLayout
 * adding buy mechanics and bundles
 */
const SimpleView = ({ hasAvailableBundles, setOffices }) => {
  const [hasPoints, setPoints] = useState(false);

  useEffect(() => {
    if (!hasPoints) {
      setPoints(true);
      setOffices();
    }
  });

  return (
    <SchemaProductContainer>
      <FlocktoryProductContainer>
        <ViewLayout extraChildren={hasAvailableBundles ? <BundleContainer /> : null} />
      </FlocktoryProductContainer>
    </SchemaProductContainer>
  );
};

SimpleView.propTypes = {
  /** availability props */
  hasAvailableBundles: PropTypes.bool,
  setOffices: PropTypes.func,
};

const mapStateToProps = (state) => ({
  hasAvailableBundles: getBundleAvailability(state),
});

const mapDispathToProps = {
  setOffices: setProductDetailsOfficesRaw,
};

export default connect(mapStateToProps, mapDispathToProps)(SimpleView);
